var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var ItemSubItemService = /** @class */ (function (_super) {
    __extends(ItemSubItemService, _super);
    function ItemSubItemService(logger, api, colservice) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this.total = 0;
        _this.price = 0;
        _this._subject = new Subject();
        return _this;
    }
    Object.defineProperty(ItemSubItemService.prototype, "observable", {
        get: function () {
            return this._subject.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    ItemSubItemService.prototype.setPrice = function (total, price) {
        this.total = total;
        this.price = price;
    };
    ItemSubItemService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var its = [];
        var check = true;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.$type === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkVal(item.child_item_id) || !this.colservice.checkVal(item.item_price) || !this.colservice.checkVal(item.item_num)) {
                check = false;
            }
            its.push(item);
        }
        if (its.length === 0) {
            check = false;
        }
        if (this.total !== this.price) {
            check = false;
        }
        if (!check) {
            this._subject.next(true);
        }
        return check;
    };
    ItemSubItemService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ItemSubItemService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService }
    ]; };
    return ItemSubItemService;
}(ContentBaseService));
export { ItemSubItemService };
var Item = /** @class */ (function () {
    function Item() {
        this.$type = "post" /* Post */;
        this.standard_price = 0;
        this.item_price = 0;
        this.item_diff_price = 0;
        this.item_num = 1;
        this.item_subtotal = 0;
    }
    return Item;
}());
export { Item };
//# sourceMappingURL=item-subitem.service.js.map